import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ListItem, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateReel } from "../../../../api/api";
import { ReelWithCategory } from "../../../../interfaces/tell_me_watch/reel.types";
import { AppState } from "../../../../store/store";
import { getDataSetToRedux } from "../../../../utility/getAffirmationAndCategory";

interface Props {
    open: boolean,
    reel: ReelWithCategory,
    handleClose: VoidFunction,
}

const ReelsUpdateDialog = (props: Props) => {
    const dispatch = useDispatch();
    const categories = useSelector((appstate: AppState) => appstate.reelsCategories);
    const [idText, setIdText] = useState("");
    const [selectedCategoryIds, setSelectedCategories] = useState<string[]>([]);

    useEffect(() => {
        setIdText(props.reel.id);
        setSelectedCategories(props.reel.categoryIds);
    }, [props.reel]);

    const handleSubmit = async () => {
        if (selectedCategoryIds.length !== 0) {
            console.log(selectedCategoryIds);
            const response = await updateReel(props.reel.id, selectedCategoryIds);
            await getDataSetToRedux(dispatch);

            props.handleClose();

            if (response.success) {
                alert("Success");
            } else {
                console.log(response.message);
                alert("Error")
            }
        }else{
            alert("Select one or more categories");
        }

    }
    const handleClose = () => {
        props.handleClose();
        setIdText("");
        setSelectedCategories([]);
    }

    return (
        <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle style={{ width: 400 }} id="form-dialog-title">Update a Reel</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Select one or more category for the reel.
                </DialogContentText>

                <Box height={15} />
                <TextField
                    style={{ width: 200, marginLeft: 20, display: "flex", alignSelf: "flex-starts" }}
                    autoFocus
                    margin="dense"
                    label="Youtube Video Id"
                    type="email"
                    helperText="11 characters"
                    value={idText}

                />
                <Box height={15} />
                {
                    categories.map((category) => {

                        let selected = false;
                        if (selectedCategoryIds.includes(category.id)) {
                            selected = true;
                        }


                        return (
                            <ListItem id={category.id}>
                                <Checkbox
                                    checked={selected}
                                    onChange={() => {
                                        if (selectedCategoryIds.includes(category.id)) {
                                            const temp = [...selectedCategoryIds];
                                            const deleteIndex = temp.indexOf(category.id);
                                            temp.splice(deleteIndex, 1);
                                            setSelectedCategories(temp);
                                        } else {
                                            setSelectedCategories([...selectedCategoryIds, category.id])
                                        }
                                    }}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                                {category.name}
                            </ListItem>
                        )
                    })
                }
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>

                    <Button onClick={handleSubmit} color="primary">
                        Update
                    </Button>
                </DialogActions>

            </DialogContent>
        </Dialog>
    );
}

export default ReelsUpdateDialog;